import { hasPermission } from "./permissions.js";

export const canManagePayment = (user, action) =>
  ["Admin", "ASD", "Authorizer", "Viewer"].includes(user?.Type) &&
  hasPermission(user, `payment.${action}`);

export const canResetPayments = (user) =>
  canManagePayment(user, "reset") && user?.IsSuperAdmin === true;
